/**
 * Persisted rule payloads for native sync only (domains + keywords).
 * Does not store browsing history.
 */

import AsyncStorage from "@react-native-async-storage/async-storage";

const CACHE_KEY = "lastNativeRulesJson_v1";
const LAST_SYNC_AT_KEY = "lastNativeRulesSyncAt_v1";

export async function saveLastSyncedRulesJson(jsonString) {
  await AsyncStorage.setItem(CACHE_KEY, jsonString);
}

export async function saveLastRulesSyncAtMs(epochMs) {
  const n = Number(epochMs);
  if (!Number.isFinite(n) || n <= 0) return;
  await AsyncStorage.setItem(LAST_SYNC_AT_KEY, String(Math.floor(n)));
}

export async function loadLastSyncedRulesJson() {
  try {
    const s = await AsyncStorage.getItem(CACHE_KEY);
    return typeof s === "string" ? s : null;
  } catch {
    return null;
  }
}

export async function loadLastRulesSyncAtMs() {
  try {
    const s = await AsyncStorage.getItem(LAST_SYNC_AT_KEY);
    const n = Number(s);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}
